/**
 * @param state
 * @returns {[]}
 */
export function holidays(state) {
    return state.holidays;
}

/**
 * @param state
 * @returns {[]}
 */
export function countryHolidays(state) {
    return state.country_holidays;
}
